import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@service/auth.service';
import { Module } from '@type/module.type';
import { MessageService } from 'primeng/api';

export function hasAccessToModule(
  module: Module,
): CanActivateFn {
  return () => {
    const authService: AuthService = inject(AuthService);
    const messageService: MessageService = inject(MessageService);
    const router: Router = inject(Router);

    const accessState = authService.hasUserAccessToModule(module);

    if (!accessState) {
      messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have access to this module.',
      });
      router.navigate([authService.isUserLoggedIn ? '/not-found' : '/login'], { replaceUrl: true });
      return false;
    }

    return true;
  };
}

export const hasAccessToSubmodule: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService: AuthService = inject(AuthService);
  const messageService: MessageService = inject(MessageService);
  const router: Router = inject(Router);

  const accessState = authService.hasUserAccessToSubmodule(state?.url);

  if (!accessState) {
    messageService.add({
      severity: 'error',
      summary: 'Access Denied',
      detail: 'You do not have access to this submodule.',
    });
    router.navigate([authService.isUserLoggedIn ? '/not-found' : '/login'], { replaceUrl: true });
    return false;
  }

  return true;
};
